import { cap } from '../../State'
import { translations } from '../../translations'

/**
 * Componente spinner riutilizzabile con variante fullscreen
 * @param {Object} props
 * @param {number} [props.size] - Dimensione in pixel dello spinner
 * @param {string} [props.color] - Colore personalizzato per il bordo attivo
 * @param {Object} [props.style] - Stili aggiuntivi inline
 * @param {boolean} [props.fullscreen] - Se true mostra l'overlay a schermo intero
 */
export const Spinner = ({ size, color, style, fullscreen = false }) => {
  const spinnerSize = size || (fullscreen ? 60 : 40)
  const language = cap.language.state || 'IT'
  const t = translations[language] || translations.IT
  const borderColor = color || 'var(--primary)'

  if (fullscreen) {
    return (
      <div className="nora-spinner-overlay" style={style}>
        <div className="nora-spinner-overlay__card">
          <div
            className="nora-spinner"
            style={{
              width: `${spinnerSize}px`,
              height: `${spinnerSize}px`,
              borderTopColor: borderColor,
              marginBottom: 20
            }}
          />
          <div className="nora-spinner-overlay__text">{t.caricamento}</div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="nora-spinner"
      style={{
        width: `${spinnerSize}px`,
        height: `${spinnerSize}px`,
        borderTopColor: borderColor,
        marginTop: 10,
        ...style
      }}
    />
  )
}
